import React, { useState } from "react";
import axios from "axios";

function Messages() {
  const [phoneNumber, setPhoneNumber] = useState("");

  const accessToken = ""
  const sendMessage = async () => {
    const url = `https://graph.facebook.com/v21.0/508357179028347/messages`;
    const body = {
      messaging_product: "whatsapp",
      to: phoneNumber,
      type: "template",
      template: {
        name: "hello_world",
        language: {
          code: "en_US",
        },
      },
    };

    try {
      const response = await axios.post(url, body, {
        headers: {
            Authorization: `Bearer EAAPvn7CZC8gYBO6FORUeZCZCHiBIUeT0hyP9ZCDGl9lkGyC4H3pspxhjeQERc33BtkSMFBE944dcPADMfeEg1wmfO2wZBqnMBXBeCICv4tZAdW3iASFeK58CngNyfQwxVeQyCts8ltSRbyK64lwJUJB0ngi2W5Id6xNa0FmxcZAzly6JcbX8MqWKK9M6iwwZBZCGJYLfgdnuqbVekbyEZCZBe8TZBTZCIrVsZD`,

          "Content-Type": "application/json",
        },
      });
      console.log("Message sent successfully:", response.data);
      alert("Message sent successfully!");
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Send WhatsApp Message</h1>
      <input
        type="text"
        placeholder="Enter phone number"
        className="w-80 p-2 border rounded-md shadow-sm mb-4 focus:outline-none focus:ring focus:ring-blue-300"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />
      <button
        onClick={sendMessage}
        className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-300"
      >
        Send Message
      </button>
    </div>
  );
}

export default Messages;
